export default __webpack_public_path__ + "static/media/book.c8a6fc77.svg";